import { createTheme } from "@mui/material/styles";

export const gradients = {
  hero: "linear-gradient(135deg, #E8000D 0%, #FF6B6B 100%)",
  subtle: "linear-gradient(180deg, #FFF5F5 0%, #FFFFFF 100%)",
  card: "linear-gradient(135deg, #FFFFFF 0%, #FFF0F0 100%)",
  dark: "linear-gradient(135deg, #1A1A1A 0%, #3D0003 100%)",
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#E8000D",
      light: "#FF4D55",
      dark: "#B0000A",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#FFFFFF",
      contrastText: "#E8000D",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F9F9F9",
    },
    text: {
      primary: "#1A1A1A",
      secondary: "#5C5C6E",
      disabled: "#ADADBD",
    },
    divider: "#EBEBF0",
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "3rem",
      fontWeight: 700,
      lineHeight: 1.15,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontSize: "2.25rem",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: "-0.01em",
    },
    h3: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.25rem", fontWeight: 600, lineHeight: 1.4 },
    body1: { fontSize: "1rem", lineHeight: 1.7 },
    body2: { fontSize: "0.875rem", lineHeight: 1.6 },
    caption: { fontSize: "0.75rem", lineHeight: 1.5 },
    button: { fontWeight: 600, letterSpacing: "0.02em", textTransform: "none" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
          minHeight: 44,
        },
        containedPrimary: {
          background: gradients.hero,
          color: "#FFFFFF",
          "&:hover": {
            background: gradients.hero,
            filter: "brightness(0.95)",
          },
          "&.Mui-disabled": {
            background: "#EBEBF0",
            color: "#ADADBD",
          },
        },
        outlinedPrimary: {
          borderColor: "#E8000D",
          color: "#E8000D",
          "&:hover": {
            borderColor: "#B0000A",
            backgroundColor: "rgba(232,0,13,0.04)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid #EBEBF0",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 100, fontWeight: 500 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E8000D",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E8000D",
          },
        },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#1A1A1A",
          borderBottom: "1px solid #EBEBF0",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.95rem",
          minHeight: 48,
        },
      },
    },
  },
});

export default theme;
